import { Col } from 'reactstrap'
import moment from 'moment';
import { isNull } from "../izUtils";
import TextInput from '../components/form/TextInput';
import NumberInput from '../components/form/NumberInput';
import TextArea from '../components/form/TextArea';
import Select from '../components/form/Select';
import DateInput from '../components/form/DateInput';
import MultiCheck from '../components/form/MultiCheck';
import Checkbox from '../components/form/Checkbox';
import Signature from '../components/form/custom/Signature';
import MaterialInput from '../components/form/custom/MaterialInput';
import SupervisorInput from '../components/form/custom/SupervisorInput';
import SSInspectionInput from '../components/form/custom/SSInspectionInput';
import AutocompleteInput from '../components/form/custom/AutocompleteInput';
import SelectSearch from '../components/form/custom/SelectSearch';
import ProjectMaterials from '../components/form/project/ProjectMaterials';
import TimeInput from '../components/form/TimeInput';
import LogMaterials from '../components/form/project/LogMaterials';
import ProjectTechnicians from '../components/form/project/ProjectTechnicians';
import ProjectLogs from '../components/form/project/ProjectLogs';
import TaxInput from '../components/form/custom/TaxInput';
import Wysiwyg from '../components/form/Wysiwyg';
import MultiSelect from '../components/form/custom/MultiSelect';
import ProjectStatus from '../components/form/project/ProjectStatus';
import FacilityMultiCheck from '../components/form/custom/FacilityMultiCheck';

export const linker = ({ field, inputs, history, showErrors, futureExceptions, component, textHandler, selectHandler, dateHandler, booleanHandler, multiHandler, timeHandler, projectMaterialHandler, lsName, showDictionary }) => {
    if (inputs[field]) {
        let fieldHistory = history?.[field] || [];

        switch (inputs[field].type) {
            case 'text':
                return <TextInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} history={fieldHistory} component={component} showDictionary={showDictionary} />
            case 'password':
                return <TextInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} showDictionary={showDictionary} />
            case 'number':
                return <NumberInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} history={fieldHistory} showDictionary={showDictionary} />
            case 'integer':
                return <NumberInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} history={fieldHistory} showDictionary={showDictionary} />
            case 'textarea':
                return <TextArea key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} history={fieldHistory} showDictionary={showDictionary} />
            case 'select':
                return <Select key={'input-' + inputs[field].name} data={inputs[field]} onChange={selectHandler} showErrors={showErrors} history={fieldHistory} showDictionary={showDictionary} />
            case 'datetime':
                return <DateInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={dateHandler} showErrors={showErrors} futureExceptions={futureExceptions} showTime={true} history={fieldHistory} showDictionary={showDictionary} />
            case 'date':
                return <DateInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={dateHandler} showErrors={showErrors} futureExceptions={futureExceptions} history={fieldHistory} showDictionary={showDictionary} />
            case 'multicheck':
                return <MultiCheck key={'input-' + inputs[field].name} data={inputs[field]} onChange={multiHandler} showErrors={showErrors} component={component} history={fieldHistory} showDictionary={showDictionary} />
            case 'checkbox':
                return <Checkbox key={'input-' + inputs[field].name} data={inputs[field]} onChange={booleanHandler} showErrors={showErrors} component={component} history={fieldHistory} showDictionary={showDictionary} />
            case 'bool':
                return <Checkbox key={'input-' + inputs[field].name} data={inputs[field]} onChange={booleanHandler} showErrors={showErrors} component={component} history={fieldHistory} showDictionary={showDictionary} />
            case 'time':
                return <TimeInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={timeHandler} showErrors={showErrors} showDictionary={showDictionary} />
            case 'selectsearch':
                return <SelectSearch key={'input-' + inputs[field].name} data={inputs[field]} onChange={selectHandler} showErrors={showErrors} showDictionary={showDictionary} />
            case 'facility_multicheck':
                return <FacilityMultiCheck key={'input-' + inputs[field].name} data={inputs[field]} onChange={multiHandler} showErrors={showErrors} component={component} history={fieldHistory} showDictionary={showDictionary} />
            case 'wysiwyg':
                return <Wysiwyg key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} history={fieldHistory} />
            // CUSTOM INPUTS
            case 'signature':
                return <Signature key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} showErrors={showErrors} history={fieldHistory} />
            case 'material':
                return <MaterialInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} history={fieldHistory} />
            case 'supervisors':
                return <SupervisorInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} showDictionary={showDictionary} />
            case 'security_system_inspections':
                return <SSInspectionInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} />
            case 'facility_search':
                return <AutocompleteInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={selectHandler} showErrors={showErrors} />
            case 'tax':
                return <TaxInput key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} onBlur={textHandler} showErrors={showErrors} showDictionary={showDictionary} />
            // PROJECT INPUTS - admin
            case 'project_materials':
                return <ProjectMaterials key={'input-' + inputs[field].name} data={inputs[field]} onChange={projectMaterialHandler} showErrors={showErrors} lsName={lsName} />
            case 'project_log_materials':
                return <ProjectMaterials key={'input-' + inputs[field].name} data={inputs[field]} onChange={projectMaterialHandler} showErrors={showErrors} />
            case 'project_logs':
                return <ProjectLogs key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} showErrors={showErrors} />
            // PROJECT INPUTS - technician
            case 'log_materials':
                return <LogMaterials key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} showErrors={showErrors} />
            case 'project_technicians':
                return <ProjectTechnicians key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} showErrors={showErrors} />
            case 'project_status':
                return <ProjectStatus key={'input-' + inputs[field].name} data={inputs[field]} onChange={textHandler} showErrors={showErrors} />
            default:
                console.log("Add new field type to 'linker' - " + inputs[field].type)
                return null
        }
    }
}

export const transformer = (fields) => {
    if (!isNull(fields)) {
        let data = {};
        for (let i = 0; i < fields.length; i++) {
            if (fields[i].type === "multicheck" && fields[i].value === '') {
                fields[i].value = [];
                data[fields[i].name] = fields[i];
            } else if (fields[i].type === "facility_multicheck") {
                if (fields[i].value === '') {
                    fields[i].value = [];
                } else if (Array.isArray(fields[i].value)) {
                    fields[i].value = fields[i].value.map(item => {
                        let facilityId = item.id;
                        while (typeof facilityId === 'object' && facilityId !== null && facilityId.id) {
                            facilityId = facilityId.id;
                        }
                        return {
                            id: facilityId,
                            security_systems: Array.isArray(item.security_systems) ? item.security_systems : []
                        };
                    });
                }
                data[fields[i].name] = fields[i];
            } else if (fields[i].type === "date" && !isNull(fields[i].value) && fields[i].value.length !== 0) {
                fields[i].value = moment(fields[i].value).format('YYYY-MM-DD');
                data[fields[i].name] = fields[i];
            } else {
                data[fields[i].name] = fields[i];
            }
        }

        return data;
    }
}

export const transformerForPublic = (fields) => {
    if (!isNull(fields)) {
        let data = {};
        for (let i = 0; i < fields.length; i++) {
            fields[i].disabled = true;

            if (fields[i].type === "select") {
                fields[i].values = [{
                    id: fields[i].value.id,
                    title: fields[i].value.title,
                }];
                fields[i].value = fields[i].value.id;
            } else if (fields[i].type === "multicheck" || fields[i].type === "technicians") {
                if (fields[i].value === '') fields[i].value = [];
                fields[i].values = fields[i].value.map(val => val)
                fields[i].value = fields[i].value.map(val => val.id)
            } else if (fields[i].type === "files") {
                fields[i].values = fields[i].value
            }

            data[fields[i].name] = fields[i];
        }

        return data;
    }
}

export const linkerFilter = ({ field, lsFilterName, inputs, col, textHandler, selectHandler, dateHandler, booleanHandler, autocompleteHandler, showDictionary }) => {
    let displayField = null;
    if (inputs[field]) {
        switch (inputs[field].type) {
            case 'text':
                displayField = <TextInput data={inputs[field]} onChange={textHandler} lsFilterName={lsFilterName} showDictionary={showDictionary} />
                break;
            case 'select':
                displayField = <Select data={inputs[field]} onChange={selectHandler} lsFilterName={lsFilterName} showDictionary={showDictionary} />
                break;
            case 'date':
                displayField = <DateInput data={inputs[field]} onChange={dateHandler} showTime={false} lsFilterName={lsFilterName} />
                break;
            case 'checkbox':
                displayField = <Checkbox data={inputs[field]} onChange={booleanHandler} lsFilterName={lsFilterName} />
                break;
            case 'facility_search':
                displayField = <AutocompleteInput data={inputs[field]} onChange={autocompleteHandler} />
                break;
            case 'selectsearch':
                displayField = <SelectSearch data={inputs[field]} onChange={selectHandler} lsFilterName={lsFilterName} showDictionary={showDictionary} />
                break;
            case 'number':
                displayField = <NumberInput data={inputs[field]} onChange={textHandler} lsFilterName={lsFilterName} />
                break;
            case 'integer':
                displayField = <NumberInput data={inputs[field]} onChange={textHandler} lsFilterName={lsFilterName} />
                break;
            case 'multiselect':
                displayField = <MultiSelect data={inputs[field]} onChange={selectHandler} lsFilterName={lsFilterName} showDictionary={showDictionary} />
                break;
            default:
                console.log("Add new field type to 'linkerFilter' - " + inputs[field].type)
                return null;
        }

        if (inputs[field].display) {
            return <Col sm={col.sm} md={col.md} lg={col.lg} xl={col.xl} key={'input-' + inputs[field].name}>{displayField}</Col>
        }
    }
}